export default {
  checkAll: 'Check All',
  createTodoList: 'Create To-do List',
  editTodoList: 'Edit To-do List',
  plural: 'To-do List',
  uncheckAll: 'Uncheck All',
  enterListTitle: 'Enter list title'
};
